import {Input, message} from "antd";
import React, {ReactElement, useCallback, useEffect, useMemo, useState} from "react";
import {RouteComponentProps, withRouter} from "react-router-dom";
import {ExternalModuleDto} from "./ExternalModuleDto";
import {BasePathUrl} from "../../appsettings";
import s from "./modulesList.module.css";
import search_icon from "../../assets/images/search_icon.svg";
import {trim} from "lodash";

export const getModules = async (): Promise<ExternalModuleDto[]> => {
  const response = await fetch(`${BasePathUrl}/ui-api/registration/modules`);
  return response.json();
};


const ModulesList = (props: RouteComponentProps): ReactElement => {
  const [modules, setModules] = useState<ExternalModuleDto[]>([]);
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    const inner = async () => {
      try {
        const externalModules = await getModules();
        setModules(externalModules);
      } catch (e) {
        message.error("Не удалось получить информацию о модулях.");
        console.error(e);
      }
    };

    inner();
  }, []);

  const renderModules = () => {

    let _modules = modules;
    if(trim(searchValue)) {
      _modules = _modules.filter((elem) => {
        return !!~elem.name.toLowerCase().indexOf(trim(searchValue.toLowerCase()));
      });
    }

    return _modules.map((element) => (

      <div
        key={element.code}
        className={s.modulesList__item}
        onClick={() => window.location.href = element.formUrl}
      >
        <div className={s.item__iconBlock}>
          <img
            className={s.item__iconImg}
            src={process.env.PUBLIC_URL + "/" + element.icon}
          />
        </div>
        <span className={s.item__name}>
          {element.name}
        </span>
      </div>
    ));
  };


  return (
    <div className={s.container}>

      <div className={s.container__title}>
        Доступные для регистрации информационные системы
      </div>

      <div className={s.container__search}>
        <Input
          value={searchValue}
          placeholder={"Поиск"}
          onChange={(e) => setSearchValue(e.target.value)}
        />
        <img src={search_icon} alt="search" />
      </div>

      <div className={s.separator} />

      <div className={s.modulesList}>
        {renderModules()}
      </div>

      <div className={s.footer}>
        <span className={`${s.font__small} ${s.font__blue}`}>Возникли проблемы со входом?</span>
        <br/>
        <div className={s.font__gray}>
          Обратитесь в службу <a href="https://my-sp.ru">технической поддержки</a>
        </div>
      </div>

    </div>
  );
};

export default withRouter(ModulesList);
